import React from "react";
import { bool, node } from "prop-types";
import { HeroCol, HeroRow } from "./Grid";

const HeroAction = ({ center = true, children }) => (
	<HeroRow center={center} className="section-hero__action">
		<HeroCol>{children}</HeroCol>
	</HeroRow>
);

HeroAction.propTypes = {
	center: bool,
	children: node.isRequired,
};

export default HeroAction;
